module.exports = __webpack_public_path__ + "img/m-circle.0264a057.png";